export const isArrayCheck = (data) => {
  return Array.isArray(data) && data.length > 0;
};

export const makeKnowledgeBaseDataRow = (arrData, setData, categoriesData) => {
  var val = isArrayCheck(arrData)
    ? arrData.map((data, id) => ({
        id: id + 1,
        image: data?.thumbnail,
        title: data?.title,
        category: isArrayCheck(categoriesData)
          ? categoriesData.find((cat) => cat.id === data?.category_id)?.title
          : "",
        dateAdded: String(data?.createdAt).substring(0, 10),
        lastModified: String(data?.updatedAt).substring(0, 10),
        views: data?.views,
        createdBy: "Agentname",
      }))
    : [];
  // console.log('Row Data', towns_listing);
  setData(val);
};

export const removeEmpty = (obj) => {
  if (typeof obj !== "object" || obj === null) return obj;

  return Object.entries(obj).reduce((acc, [key, value]) => {
    // Recursively clean nested objects
    const cleanedValue =
      typeof value === "object" && !Array.isArray(value)
        ? removeEmpty(value)
        : value;

    const isEmpty =
      cleanedValue === "" ||
      cleanedValue === null ||
      cleanedValue === undefined ||
      (typeof cleanedValue === "object" &&
        !Array.isArray(cleanedValue) &&
        Object.keys(cleanedValue).length === 0);

    if (!isEmpty) {
      acc[key] = cleanedValue;
    }

    return acc;
  }, {});
};
